<template>
  <Nav-bar :has_back="true" :has_right="false" title="输入序列号"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container">
    <van-field
      class="input-sytle"
      v-model="numberCode"
      placeholder="请输入充电桩序列号"
    />
    <div class="btn-container">
      <div class="btn-v" @click="goBack">
        <van-button type="primary" size="normal" plain class="main-btn"
          >切换扫码</van-button
        >
      </div>
      <div class="btn-v m-l-15">
        <van-button
          type="primary"
          size="normal"
          class="main-btn"
          @click="checkChargeNumber"
          >确定</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { ref ,onUnmounted} from "vue";
import { useRouter } from "vue-router";
import request from "@/api/request";
let numberCode = ref("");
 let  router
export default {
  components: {
    NavBar,
  },
  setup() {
     router = useRouter();

    function goBack() {
    
      router.back();
    }
    //监听页面销毁
      onUnmounted(()=>{
        numberCode.value = ""
      })
    return { numberCode, goBack,checkChargeNumber };
  },
};
//查询电桩信息
function checkChargeNumber() {
  request
    .getChargersDetails(numberCode.value)
    .then(() => {
      router.push(`/station/charge_details/${numberCode.value}`);
    })
  
}
</script>

<style scoped>
body {
  background: #fff !important;
}
.container {
  padding: 30px;
}
.input-sytle {
  border: 1px solid #ebebeb;
  margin-top: 20px;
  border-radius: 10px;
  font-size: 16px;
  height: 48px;
  color: #1a1a1a;
}
.btn-container {
  margin-top: 25px;
  display: flex;
}
.btn-v {
  flex: 1;
}
</style>